export interface AdminDrawerItem {
  id: string;
  label: string;
}

export const AdminDrawerData: AdminDrawerItem[] = [
  {
    id: 'mandate-templates',
    label: 'Mandate Templates'
  },
  {
    id: 'create-template',
    label: 'Create a template'
  },
  {
    id: 'manage-templates',
    label: 'Manage Templates'
  }
];
